// extracted by mini-css-extract-plugin
module.exports = {"container":"graphic-card_container__d_3DS","content":"graphic-card_content___B8_X"};